// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2O_4A","head":"Table_head__2stHc","col":"Table_col__3-7Bu"};